import axios from "../../config/interceptor";

export const getScheduleDoctor = async (doctorId) => {
  try {
    const response = await axios.get(
      `/lambda/get-doctor-schedule/${doctorId}`
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const upsertScheduleDoctor = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/save-schedule-doctor`,
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getAvailableSlotDoctor = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/get-available-slots`,
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};
